import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatDateToIST,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
  formatTo12Hour,
  formatTimeInIST,
  PaymentMethods,
} from "../../../../utils/common";
import ProductModal from "../ProductModal";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
// import AssignOffCanvance from "../AssignDeliveryBoy";
// import ProductModal from "../ProductModal";
// import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";

import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function PendingOrdersTable({
  user,
  OrderByOptions,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });
  const [loader, setLoder] = useState("");
  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();

  const getDataAll = async () => {
    setLoder(true);
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Processing || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
    setLoder(false);
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
      await GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Processing || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end">
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  max="9999-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  max="9999-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12 d-flex align-items-end gap-2">
              <Button
                type="button"
                onClick={getDataAll}
                className="btn btn-search"
              >
                <img src={search1} className="search" alt="" />
              </Button>
              <button
                type="button"
                onClick={() => {
                  setSearch("");
                  setSearchCustomerContact("");
                  setSearchDateFrom("");
                  setSearchDateTo("");
                  setSearchEndTime("");
                  setSearchStartTime("");
                  setSearchCustomer("");
                  setProductCategory("");
                  setReset(!reset);
                }}
                className="btn btn-reset"
              >
                Reset
              </button>
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Download Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        {/* <div>
          <strong>Total Order:</strong>
          {data?.data?.data?.length}
        </div>
        <div>
          <strong>Total Amount:</strong> ₹
          {Number(data?.data?.total_selling_value || 0).toFixed(2)}
        </div>
        <div>
          <strong>Average Amount:</strong> ₹
          {Number(data?.data?.average_selling_value || 0).toFixed(2)}
        </div> */}
        {/* <div>
          <strong>Total Kg:</strong>{" "}
          {Number(data?.data?.total_weight || 0).toFixed(2)} kg
        </div> */}
      </div>

      {/* Table Section */}
      {loader ? (
        <>
          <div className="text-center">
            <ClipLoader />
          </div>
        </>
      ) : (
        <div className="pending-table ">
          <Table striped bordered hover className="order-table" responsive>
            <thead>
              <tr>
                <th>Order Date</th>
                <th>Order details</th>

                <th>Products</th>
                <th>Total</th>
                <th>Delivery Details</th>
                <th>Order Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="order-date">
                    <div className="order-id">
                      {formatDateToIST(item?.createdAt)}
                      {/* {item?.createdAt} */}
                    </div>
                    {/* <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div> */}
                    <div className="order-info">
                      <span>{formatTimeInIST(item?.createdAt)} IST</span>
                    </div>
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.invoice_no}
                    </div>
                    <div className="order-info"></div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name :</b>
                      </span>
                      <span className="text-highlight">{item?.User?.name}</span>
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Contact No:</b>
                      </span>
                      <span className="order-info">
                        {item?.User?.contact_no}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>
                        <b>Payment Method :</b>
                      </span>
                      <span>{item?.Payment_Method?.name}</span>
                    </div>
                    {Number(item?.Payment_Method?.id) ===
                      Number(PaymentMethods.Online) && (
                      <div className="order-info">
                        <span>
                          <b>Payment Id </b>
                        </span>
                        <span>{item?.Order_Payment_Detail?.payment_id}</span>
                      </div>
                    )}
                  </td>

                  <td className="order-details">
                    {item?.Product_Order_Details?.map((product,prodIndex) => (
                      <>
                        <div className="index_div">
                          <p className="index_no"> {prodIndex + 1}.</p>
                          <div className="all_data">
                            <div className="text-highlight">
                              <span>
                                <b>Product Name </b>
                              </span>
                              :-<span>{product?.Product?.name}</span>
                            </div>
                            {/* <div className="order-info">
                          <span>
                            <b>Category Name</b>
                          </span>
                          :-<span>{product?.Product?.p_category?.name} </span>
                        </div> */}
                          </div>
                        </div>
                      </>
                    ))}
                    <div></div>
                    <div className=" mt-3">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          setShowDetails({
                            show: item?.id,
                            data: item?.Product_Order_Details,
                          })
                        }
                      >
                        View All Details
                      </Button>
                    </div>
                  </td>

                  <td className="order-details">
                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Total SubTotal :-</b>
                      </span>
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_selling_price).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Delivery Charges :- </b>
                      </span>
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.delivery_charges).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Coupon Discount :- </b>
                      </span>
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_coupon_discount).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Discount :-</b>
                      </span>
                      <span>
                        {Number(item?.total_refer_discount).toFixed(2) || 0} /-
                      </span>
                    </div>

                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Total Tax :- </b>
                      </span>
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_tax).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Grand Total :-</b>
                      </span>
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_amount).toFixed(2)} /-
                      </span>
                    </div>

                    <div className="order-id no_wrap_holder">
                      <span>
                        <b>Wallet Discount :-</b>
                      </span>
                      <span>
                        ₹{Number(item?.wallet_discount).toFixed(2) || 0} /-
                      </span>
                    </div>
                  </td>

                  <td>
                    <>
                      <div className="text-highlight">
                        {/* <p> 
                           {item?.address_id}
                        </p>
                        <p>{item?.billing_address_id}</p> */}

                        <span>
                          {item?.User_Address?.first_name}{" "}
                          {item?.User_Address?.last_name}
                        </span>
                      </div>
                      <div className="order-info">
                        {/* <strong>Address type: </strong>
                        {item?.User_Address?.address_type_id === 1
                          ? "Home"
                          : item?.User_Address?.address_type_id === 2
                            ? "Apartment"
                            : item?.User_Address?.address_type_id === 3
                              ? "Work"
                              : item?.User_Address?.address_type_id === 4
                                ? "Office"
                                : "other"}{" "}
                        <br></br> */}
                        <strong> Shipping Address : </strong> <br></br>
                        <span>{item?.User_Address?.floor} floor ,</span>
                        <span>{item?.User_Address?.building}, </span>
                        <span>{item?.User_Address?.apartment} ,</span>
                        <span>{item?.User_Address?.street}, </span>
                        <span>{item?.User_Address?.area}, </span>
                        <span>{item?.User_Address?.direction}, </span>
                        <br></br>
                        <strong> Billing Address : </strong> <br></br>
                        <span>{item?.billing_user_address?.floor} floor ,</span>
                        <span>{item?.billing_user_address?.building}, </span>
                        <span>{item?.billing_user_address?.apartment} ,</span>
                        <span>{item?.billing_user_address?.street}, </span>
                        <span>{item?.billing_user_address?.area}, </span>
                        <span>{item?.billing_user_address?.direction}, </span>
                      </div>
                      <div className="order-info">
                        {/* <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Country
                              ?.name
                          }{" "}
                          ,
                        </span> */}
                        {/* <span>
                          {item?.User_Address?.Users_Address_Detail?.State?.name}
                          ,{" "}
                        </span> */}
                        <span>
                          <strong>
                            {" "}
                            {
                              item?.User_Address?.Users_Address_Detail?.City
                                ?.name
                            }{" "}
                          </strong>
                          ,
                        </span>
                        {/* <span>
                          {item?.User_Address?.Users_Address_Detail?.Area?.name}
                          ,{" "}
                        </span> */}
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Pincode
                              ?.name
                          }
                          ,{" "}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>{item?.User_Address?.address_type}</span>
                      </div>
                      <div className="text-highlight">
                        <span>{item?.User_Address?.contact_no} </span>
                      </div>

                      {/* @@@ */}

                      <div className="text-highlight">
                        <span>
                          <b>Delivery Note :</b>
                        </span>{" "}
                        <span>{item?.delivery_note} </span>
                      </div>

                      <div className="text-highlight">
                        {/* <span><b>Time Slot :</b></span> <span>{item?.Time_Slot?.from } to {item?.Time_Slot?.to } </span> */}
                        {/* <span>
                          <b>Time Slot :</b>
                        </span>
                        <span>
                          {item?.Time_Slot
                            ? `${formatTo12Hour(item?.Time_Slot?.from)} to ${formatTo12Hour(item?.Time_Slot?.to)}`
                            : "null"}
                        </span> */}
                      </div>

                      {/* {(() => {
                    
                        return null;
                      })()} */}
                    </>
                  </td>

                  <td>
                    {item?.order_status_id === 4 ? (
                      <div>
                        <p className="status-holder shipped">
                          {item?.Order_status?.name}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p className="status-holder Unshipped">
                          <b>{item?.Order_status?.name}</b>
                        </p>
                      </div>
                    )}
                  </td>

                  <td>
                    <div className="my-1">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          ChangeOrderStatus(item?.id, OrderStatusIds.Preparing)
                        }
                      >
                        {" "}
                        Send Preparing Order{" "}
                      </Button>
                    </div>

                    <div className="my-1">
                      <Button
                        className="action-btn"
                        onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                      >
                        Print Invoice
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {data && data?.data?.data?.length > 0 ? (
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          ) : (
            <p className="no-datashow">Sorry, No Data Found</p>
          )}
        </div>
      )}

      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
    </section>
  );
}

export default PendingOrdersTable;
